export enum SecurityVerificationType {
	PIN_CODE,
	AUTHENTICATOR_CODE,
	NONE
}

export interface AntiPhishingPutPayload {
	code: string;
	sms_pin_code?: string;
	auth_code?: string;
}

export interface AntiPhishingResponse {
	code: string;
}

export enum AntiPhishingBlockType {
	HALF,
	FULL,
	NONE
}
